import axios from 'axios';
import React, { useState } from 'react';
import { MessageBox } from 'react-chat-elements';
import 'react-chat-elements/dist/main.css';
import { PostApi } from '../Api/BaseHandle';
import SendIcon from '@mui/icons-material/Send';
const ChatInterface = () => {
  const [messages, setMessages] = useState([]);
  const [userMessage, setUserMessage] = useState('');

  const sendMessage = async () => {
    if (userMessage.trim()) {
      // Add user message to the chat
      const newMessages = [
        ...messages,
        { type: 'text', text: userMessage, position: 'right', title: 'You' }
      ];
      setMessages(newMessages);
      setUserMessage('');

      // Send user message to the API
      try {
        const response = await PostApi("/dialogflow", { query: userMessage });
        const botMessage = response.data.fulfillmentText;
        // Add bot response to the chat
        setMessages([
          ...newMessages,
          { type: 'text', text: botMessage, position: 'left', title: 'AI Bot' }
        ]);
      } catch (error) {
        console.error('Error:', error);
        // Handle error (optional)
      }
    }
  };

  return (
    <div className="chat-container">
      {/* Profile Image at the top */}
      <div className="chat-header">
        <img
          src={require("../robot-removebg-preview.png")}
          alt="Bot Avatar"
          className="chat-avatar"
        />
        <span className="chat-title">
          AI Bot (Hafeez)
          <span className="online-indicator"></span>
        </span>
      </div>

      {/* Chat Messages */}
      <div className="message-list">
        {messages.map((msg, index) => (
          <MessageBox
            key={index}
            position={msg.position}
            type={msg.type}
            text={msg.text}
            title={msg.title}
            titleColor={msg.position === 'left' ? '#000000' : '#007bff'}
          />
        ))}
      </div>

      {/* Message Input */}
      <div className="message-input">
        <input
          type="text"
          value={userMessage}
          onChange={(e) => setUserMessage(e.target.value)}
          placeholder="Type your message..."
        />
        <button onClick={sendMessage}><SendIcon /></button>
      </div>
    </div>
  );
};

export default ChatInterface;
